module.exports = __webpack_public_path__ + "static/media/cellfinate_banner_diagnostico_mobile.28a91fca.jpg";